import { motion } from "framer-motion";
import { FlaskConical, ArrowRight } from "lucide-react";
import Slash from "./Slash";
import ScrambleText from "./ScrambleText";
import { ParallaxShader, ParallaxSpan, PointerLayer } from "./Parallax";
import { usePageTransition } from "./PageTransition";
import { buzz } from "../lib/haptics";

export default function LabCTA() {
  const transition = usePageTransition();
  return (
    <section id="lab" data-testid="lab-cta" className="relative overflow-hidden bg-[#070707] py-24 md:py-32">
      <ParallaxShader variant="embers" intensity={0.9} strength={24} />
      <ParallaxSpan className="ambient-red" style={{ width: "36rem", height: "36rem", top: "-6rem", right: "-10rem" }} strength={48} />
      <ParallaxSpan className="section-kanji font-jp bottom-2 left-4 text-[9rem] md:text-[14rem]" strength={90}>
        量
      </ParallaxSpan>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-15%" }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="relative z-10 mx-auto max-w-[1100px] px-6 text-center md:px-12"
      >
        <ScrambleText
          as="span"
          text="03 — THE LAB"
          className="font-mono2 mb-4 block text-xs uppercase tracking-[0.4em] text-[#d91616]"
        />
        <PointerLayer strength={-14}>
          <h2 className="font-display text-4xl font-black leading-[0.95] tracking-tighter md:text-6xl">
            PRECISION IS A <span className="text-stroke-red">DISCIPLINE.</span>
          </h2>
        </PointerLayer>
        <p className="mx-auto mt-6 max-w-xl font-body text-sm leading-relaxed text-white/55 md:text-base">
          Reconstitute with confidence. The Toji peptide calculator gives you the exact
          syringe draw for any vial, dose, and syringe size.
        </p>
        <button
          data-testid="enter-lab-btn"
          onClick={() => {
            buzz(12);
            transition ? transition.go("/lab") : (window.location.href = "/lab");
          }}
          className="slash-host group mx-auto mt-10 inline-flex items-center gap-3 border border-[#d91616] bg-[#d91616] px-6 py-4 font-mono2 text-[11px] uppercase tracking-[0.25em] text-white transition-colors hover:bg-transparent hover:text-[#d91616] sm:px-8 sm:text-xs sm:tracking-[0.3em]"
        >
          <FlaskConical size={16} />
          Enter the Lab
          <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
          <Slash />
        </button>
      </motion.div>
    </section>
  );
}
